import axios from 'axios';
import { Toast } from 'vant';
import { getUserInfo, removeUserInfo, globalObj } from './api-service';
import router from '@/router';
export const _baseUrl = window.config.baseUrl;
export const _homeUrl = window.config.homeUrl;

axios.defaults.timeout = 6000000000000000;
axios.defaults.baseURL = '';

//响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          console.error('错误请求');
          break;
        case 401:
          console.error('未授权，请重新登录');
          break;
        case 403:
          console.error('拒绝访问');
          break;
        case 404:
          console.error('请求错误,未找到该资源');
          break;
        case 405:
          console.error('请求方法未允许');
          break;
        case 408:
          console.error('请求超时');
          break;
        case 500:
          console.error('服务器端出错');
          break;
        case 501:
          console.error('网络未实现');
          break;
        case 502:
          console.error('网络错误');
          break;
        case 503:
          console.error('服务不可用');
          break;
        case 504:
          console.error('网络超时');
          break;
        case 505:
          console.error('http版本不支持该请求');
          break;
        default:
          console.error(`连接错误${err.response.status}`);
      }
    } else {
      console.error('连接到服务器失败');
    }
    return Promise.resolve(err.response);
  }
);

export function getBaseUrl() {
  let baseUrl = _baseUrl;
  return (baseUrl = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/');
}
export function getHomeUrl(){
  let homeUrl = _homeUrl
  return (homeUrl = homeUrl.endsWith('/') ? homeUrl : homeUrl + '/');
}

export function post(url, params = {}) {
  const baseUrl = getBaseUrl();
  return _post(baseUrl + url, params, true);
}
export function post2(url, params = {}) {
  return _post(url, params, true);
}

export function postNotAddToken(url, params = {}) {
  const baseUrl = getBaseUrl();
  return _post(baseUrl + url, params, false);
}

export function postByUrl(url, params = {}, needToken = false) {
  return _post(url, params, needToken);
}
/**
 * 封装post请求
 * @param {*} url
 * @param {*} params
 * @param {*} needToken
 */
export function _post(url, params = {}, needToken) {
  return new Promise((resolve, reject) => {
    if (needToken) {
      const userInfo = getUserInfo();
      if (userInfo) {
        if (url.indexOf('?') > 0) {
          url = url + `&token=${userInfo.token}&tokenUserId=${userInfo.userId}`;
        } else {
          url = url + `?token=${userInfo.token}&tokenUserId=${userInfo.userId}`;
        }
      }
    }

    if (window.config.isApiAddfree) {
      if (url.includes('?')) {
        url = url + `&freereqstate=1`;
      } else {
        url = url + `?freereqstate=1`;
      }
    }

    axios.post(url, params).then(
      (response) => {
        //token过期处理
        let res = response.data;
        if (res.message) {
          if (
            res.message.toString().includes('延长token时间失败') ||
            res.message.toString().includes('token过时或无效') ||
            res.message.toString().includes('令牌已经过期')||
            res.message.toString().includes('令牌无效')
          ) {
            Toast({ message: '登录过期，重新登录中！', duration: 5000 });
            removeUserInfo();
            globalObj.isLoading = false;
            router.push(window.config.tokenExpiredRedirect || '/login');
          }
        }

        if (response.data.result_code === '0000') {
          response.data.success = true;
        }
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function get(url, params = {}) {
  const baseUrl = getBaseUrl();
  return _get(baseUrl + url, params, true);
}
export function get2(url) {
  const dataUrl = window.config.homeDataUrl
  return _get(dataUrl + url);
}
export function getNotAddToken(url, params = {}) {
  const baseUrl = getBaseUrl();
  return _get(baseUrl + url, params, false);
}

export function getByUrl(url, params = {}, needToken = false) {
  return _get(url, params, needToken);
}

/**
 * 封装get方法
 * @param {*} url
 * @param {*} params
 * @param {*} needToken
 */
export function _get(url, params = {}, needToken) {
  return new Promise((resolve, reject) => {
    if (needToken) {
      const userInfo = getUserInfo();
      if (userInfo) {
        if (url.indexOf('?') > 0) {
          url = url + `&token=${userInfo.token}&tokenUserId=${userInfo.userId}`;
        } else {
          url = url + `?token=${userInfo.token}&tokenUserId=${userInfo.userId}`;
        }
      }
    }

    if (window.config.isApiAddfree) {
      if (url.includes('?')) {
        url = url + `&freereqstate=1`;
      } else {
        url = url + `?freereqstate=1`;
      }
    }

    if (url.indexOf('?') > 0) {
      url = url + `&random=${Math.random()}`;
    } else {
      url = url + `?random=${Math.random()}`;
    }

    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        //token过期处理
        let res = response.data;
        if (res.message) {
          if (
            res.message.toString().includes('延长token时间失败') ||
            res.message.toString().includes('token过时或无效') ||
            res.message.toString().includes('令牌已经过期')||
            res.message.toString().includes('令牌无效')
          ) {
            Toast({ message: '登录过期，重新登录中！', duration: 5000 });
            removeUserInfo();
            globalObj.isLoading = false;
            router.push(window.config.tokenExpiredRedirect || '/login');
          }
        }

        if (response.data.result_code === '0000') {
          response.data.success = true;
        }
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 一般获取下载链接
 * @param {*} api
 * @param {*} param
 * @param {*} needToken
 */
export function getUrl(api, param = {}, needToken = true) {
  let url = getBaseUrl();
  url = url + api;

  param = param || {};
  if (needToken) {
    const userInfo = getUserInfo();
    param.token = userInfo.token;
    param.userId = userInfo.userId;
  }

  if (window.config.isApiAddfree) {
    if (url.includes('?')) {
      url = url + `&freereqstate=1`;
    } else {
      url = url + `?freereqstate=1`;
    }
  }

  let arr = [];
  for (let key in param) {
    let value = param[key];
    key = encodeURIComponent(key);
    if (value == undefined || value == null) {
      value = '';
    } else {
      value = encodeURIComponent(value);
      arr.push(`${key}=${value}`);
    }
  }

  //IE浏览器使用get去获取数据时，会使用缓存的数据作为结果
  //所以在查询字符串后面添加一个随机数
  arr.push(`randomnumber=${Math.random()}`);

  let par = arr.join('&');
  if (url.indexOf('?') > 0) {
    url = `${url}&${par}`;
  } else {
    url = `${url}?${par}`;
  }

  return url;
}
